(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-chart-container.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/components/charity-payout-chart-container.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  RadioButton,
  RadioGroup
} = svs.ui.reactForm;
const Paper = svs.ui.ReactPaper;
const {
  CONSTANTS: {
    PAYOUT_KEYS
  }
} = svs.lyckoplatsen.components.shared_constants;
const {
  CharityPayoutChart
} = svs.lyckoplatsen.components.shared_charity_payout.react.components;
const {
  useAtomValue
} = jotai;
const {
  charityPayoutsAtom
} = svs.lyckoplatsen.shared_charity_payout.jotai.atoms;
const {
  doesPayoutChartContainData
} = svs.lyckoplatsen.shared_charity_payout.utils;
const latestPrimaryDraw = svs.lyckoplatsen.data.latestPrimaryDraw;
const currentYear = new Date().getFullYear();
const selectedPayoutText = {
  [PAYOUT_KEYS.LATEST_DRAW]: latestPrimaryDraw ? "Vecka ".concat(svs.utils.date.WeekNr(latestPrimaryDraw.regCloseTime)) : '',
  [PAYOUT_KEYS.THIS_YEAR]: "Hela ".concat(currentYear),
  [PAYOUT_KEYS.SINCE_LAUNCH]: "2025 - ".concat(currentYear)
};
const CharityPayoutChartContainer = _ref => {
  var _charityPayouts$payou;
  let {
    payoutKey,
    handlePayoutKeyChange
  } = _ref;
  const charityPayouts = useAtomValue(charityPayoutsAtom);
  const payoutChartData = (_charityPayouts$payou = charityPayouts[payoutKey]) === null || _charityPayouts$payou === void 0 ? void 0 : _charityPayouts$payou.data;
  const [isHorizontal, setIsHorizontal] = useState(svs.core.detect.breakpoint.greaterThan('xs'));
  useEffect(() => {
    const listener = () => {
      if (svs.core.detect.breakpoint.lessThan('sm')) {
        setIsHorizontal(false);
      } else {
        setIsHorizontal(true);
      }
    };
    svs.core.detect.breakpoint.on('change', listener);
    return () => svs.core.detect.breakpoint.off('change', listener);
  }, []);
  if (!doesPayoutChartContainData(charityPayouts[PAYOUT_KEYS.SINCE_LAUNCH])) {
    return null;
  }
  return React.createElement("div", {
    className: "lp-charity-payout-chart-container charity-grid padding-top-1 padding-bottom-1"
  }, React.createElement("div", {
    className: "charity-grid-body"
  }, React.createElement(Paper, null, React.createElement("div", {
    className: "chartity-container-top"
  }, React.createElement("p", {
    className: "top-header"
  }, "F\xF6rdelning av bidrag"), React.createElement("p", null, selectedPayoutText[payoutKey])), React.createElement("div", {
    className: "charity-toggle-wrapper"
  }, React.createElement(RadioGroup, {
    multipleLines: true,
    size: 200
  }, React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.LATEST_DRAW,
    defaultChecked: true
  }, "Dragning"), React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.THIS_YEAR
  }, "\xC5r ", currentYear), React.createElement(RadioButton, {
    onChange: handlePayoutKeyChange,
    value: PAYOUT_KEYS.SINCE_LAUNCH
  }, "Sedan start"))), React.createElement(CharityPayoutChart, {
    payoutChartData: payoutChartData,
    fontColor: "black",
    horizontal: isHorizontal
  }))));
};
setGlobal('svs.lyckoplatsen.components.page_charity_payout.react.components', {
  CharityPayoutChartContainer
});

 })(window);